const kimlikData = [
    { kod:"TCKK", title:"TC Çipli Kimlik Kartı" },
    { kod: "TCNC", title: "TC Nüfus Cüzdanı" },
    { kod: "TCYK", title: "TC Yabancı Kimlik Belgesi" },
    { kod:"TCMA", title:"TC Mavi Kart" },
    { kod:"TCGK", title:"TC Geçici Kimlik Belgesi" },
    { kod: "TCSC", title: "TC Sürücü Belgesi" },
    
    
    { kod:"YP", title:"Yabancı Pasaport" },
    { kod:"TCPC", title:"TC Pasaportu: Yeni Tip Çipli ePasaport (Tüm Tipler)" },
    { kod:"TCPL", title:"TC Pasaportu: Eski Tip Lacivert (Umuma Mahsus)" },
    { kod:"TCPY", title:"TC Pasaportu: Eski Tip Yeşil (Hususi)" },
    { kod:"TCPG", title:"TC Pasaportu: Eski Tip Gri (Hizmet)" },
    { kod:"TCPK", title:"TC Pasaportu: Eski Tip Kırmızı (Diplomatik)" },
    { kod:"TCGP", title:"TC Pasaportu: Geçici Pasaport" },
  
    { kod:"AC", title:"Uçuş mürettebatı belgesi" },
    { kod:"GC", title:"Gemi adamı cüzdanı" },
    { kod:"NE", title:"NATO Emri belgesi" },
    { kod:"SB", title:"Seyahat Belgesi" },
    { kod:"HB", title:"Hudut Geçiş Belgesi" },
    { kod:"GK", title:"Gemi Komutanı Onaylı Personel Listesi" },
    { kod:"TCHS", title:"TC Hakim/Savcı Mesleki Kimlik Kartı" },
    { kod:"TCSV", title:"TC Avukatlık Belgesi" },
    { kod:"TCEV", title:"TC Uluslararası aile cüzdanı" }
]


export { kimlikData }